import _styled from "@emotion/styled/base";
import React from 'react';
import Img from 'gatsby-image';
import SVG from 'react-inlinesvg';
import { readableColor } from 'polished';
import { jsx as ___EmotionJSX } from "@emotion/react";
const SVGContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1smm37e0"
} : {
  target: "e1smm37e0",
  label: "SVGContainer"
})("svg{fill:", props => props.svgFill ? props.svgFill : readableColor(props.theme.base_color, '#000', '#fff'), ";width:", props => props.width, ";height:", props => props.height, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Logo = _ref => {
  let {
    logo,
    title,
    svgFill,
    svgWidth,
    svgHeight,
    imageWidth
  } = _ref;
  if (!logo.childImageSharp && logo.extension === 'svg') {
    // SVG
    return ___EmotionJSX(SVGContainer, {
      svgFill: svgFill,
      width: svgWidth,
      height: svgHeight
    }, ___EmotionJSX(SVG, {
      src: logo.publicURL,
      title: title
    }));
  } else {
    if (logo.childImageSharp.fixed) {
      // Fixed
      return ___EmotionJSX(Img, {
        style: {
          maxHeight: '80px'
        },
        fixed: logo.childImageSharp.fixed,
        alt: title,
        title: title,
        loading: 'eager'
      });
    } else {
      // Fluid
      return ___EmotionJSX(Img, {
        style: {
          maxHeight: '120px',
          maxWidth: imageWidth ? imageWidth : 'auto'
        },
        imgStyle: {
          objectFit: 'contain'
        },
        fluid: logo.childImageSharp.fluid,
        alt: title,
        title: title,
        loading: 'eager'
      });
    }
  }
};
export default Logo;